import React, {useEffect, useState} from 'react'
import { DappMenuSreen } from '../UI/DappMenuSreen';
import detectEthereumProvider from '@metamask/detect-provider'
import link from 'next/link';
import { Wallet_model } from '../../models/Wallet_model';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useHistory } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import AvatarGroup from '@mui/material/AvatarGroup';

import Chip from '@mui/material/Chip';

import DoneIcon from '@mui/icons-material/Done';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

import moment from 'moment';
import { app, db, storage } from "../../firebaseConfig/firebaseConfig";
import { getFirestore, collection, getDocs, setDoc, addDoc, doc, getDoc,query, where,updateDoc,orderBy } from 'firebase/firestore/lite';


import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));



export const DappProfileScreen = () => {
    let wallet = localStorage.getItem("wallet"); 
    let user = localStorage.getItem("email");
    const [pending,setPending ] = useState(0);
    const [complete,setComplete ] = useState(0);
    const [viewcontacts,setviewcontacts] = useState([]);
    const image = localStorage.getItem("image");

    let red = localStorage.getItem("red");

    const getInfo = async () => {
      try {
          console.log("en el info",red)
          let pendientes = 0;
          let completes = 0;
          const userref = doc(db, "users", localStorage.getItem("uid"));
          const walletdata = {
              wallet: localStorage.getItem("wallet"),
          }
          const resultuser = await getDoc(userref);
          if(resultuser.data().wallet == undefined || resultuser.data().wallet == null){ 
          await updateDoc(userref, walletdata);
          console.log("no lo va a hacer")
          }
          const q = query(collection(db, "contracts"),orderBy('create',"desc"));
          const querySnapshot = await getDocs(q);
          let info = [];
          querySnapshot.forEach((doc) => {

            
           
              // doc.data() is never undefined for query doc snapshots
              let data = doc.data();
              if(data.red == red){
              if(data.status != undefined){
                completes++;
              }else{
                pendientes++;
              }
              console.log(doc.data());
              data["id"] = doc.id;
              if(completes + pendientes < 6){
              info.push(JSON.stringify(data));
              }
            }
  
          });
          console.log(completes,pendientes,"fjsdpofjspodfjs")
          setPending(pendientes);
          setComplete(completes);
          setviewcontacts(info);
          console.log(info)
  
          if( info.length > 0){
              console.log("entra?")
              //await setcontacts("show");
             // await setviewcontacts(info);
          }
          
      } catch (error) {
          console.log(error);
          
      }
   


      
  }


  useEffect(() => {
    getInfo();
  
}, [])




    return (
        <div>
            <div className="dapp_container">
                <DappMenuSreen />

                <div className="dapp__center2">
                    <div className="dapp__profile">
                        <div className="dapp__one">

                        <Card className="dapp__c-100" style={{padding: "2rem"}} >
      <CardContent >
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            <div className="dapp__one">

        <Avatar
                            alt={user}
                            src={image}
                            sx={{ width: 54, height: 54 }}
                        />

    <h5>{wallet}</h5>

</div>
         
    <h4 className="dapp__title mt-5">{user}</h4>

        </Typography>
        <Typography className="dapp__primary mt-5" color="primary" variant="h5" component="div">
       Contratos
        </Typography>
        <Typography className="dapp__options mt-5"  color="text.secondary">
          Completados: <span className="dapp__complete"> {complete} </span>
        </Typography>
        <Typography className="dapp__options mt-5"  color="text.secondary">
          Pendientes: <span className="dapp__complete"> {pending} </span>
        </Typography>

      </CardContent>
      <CardActions>
      </CardActions>
    </Card>
                        </div>

                    </div>

                    <div className="dapp__lastMoves">
                    <Card className="dapp__c-100" >
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            <div className="dapp__one">

      

                        <h5>Ultimos movimientos</h5>

</div>
         

        </Typography>
        <Typography className="dapp__primary mt-5" color="primary" variant="h5" component="div">
        {Array.from(viewcontacts).map((_, index) => (
           <Item className="dapp__style">
            <h2>{(JSON.parse(viewcontacts[index])).name} </h2>  
            <AvatarGroup className="dapp__avatar2" max={3}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
            </AvatarGroup>
            <Chip color="primary" label="En proceso" icon={<HourglassEmptyIcon />} />
             
              <p className="dapp__contdescription">{(JSON.parse(viewcontacts[index])).description}</p>


    <p>Fecha de creación: {moment((JSON.parse(viewcontacts[index])?.create.seconds)*1000).format("DD-MM-YYYY HH:mm ")}</p>
                </Item>
       
        ))}
        </Typography>
      </CardContent>
      <CardActions>
      </CardActions>
    </Card>
                    </div>

                </div>
            </div>
        </div>
    )
}
